var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('h1',[_vm._v("お申込完了")]),_c('p',[_vm._v("ありがとうございました。お申し込みが完了しました！")]),_c('router-link',{attrs:{"to":"/"},nativeOn:{"click":function($event){return _vm.scrollToTop.apply(null, arguments)}}},[_vm._v("トップへ戻る")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }